"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusDot = exports.StatusDotProps = exports.TitleOfPane = void 0;
const typestyle_1 = require("typestyle");
const Colors_1 = require("../../../Colors");
const vars_1 = require("../../../vars");
exports.TitleOfPane = typestyle_1.style({
    padding: `10px 15px`,
    fontFamily: vars_1.fontFamily,
    fontSize: 12,
    textTransform: 'uppercase',
    color: Colors_1.Colors.grey[4],
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    zIndex: 3,
    position: 'absolute',
});
var StatusDotProps;
(function (StatusDotProps) {
    StatusDotProps["sync"] = "sync";
    StatusDotProps["nosync"] = "nosync";
    StatusDotProps["syncing"] = "syncing";
    StatusDotProps["readonly"] = "readonly";
})(StatusDotProps = exports.StatusDotProps || (exports.StatusDotProps = {}));
exports.StatusDot = typestyle_1.style({
    borderRadius: '50%',
    width: 8,
    height: 8,
    background: Colors_1.Colors.grey[9],
    $nest: {
        [`&.${StatusDotProps.nosync}`]: {
            background: Colors_1.Colors.red[0],
        },
        [`&.${StatusDotProps.sync}`]: {
            background: Colors_1.Colors.green[0],
        },
        [`&.${StatusDotProps.syncing}`]: {
            background: Colors_1.Colors.main[0],
        },
        [`&.${StatusDotProps.readonly}`]: {
            background: Colors_1.Colors.blue[0],
        },
    },
});
